import instantCoffee from '../static/InstantCoffee.webp';
import flavoredGround from '../static/FlavoredGround.webp';
import classicGround from '../static/ClassicGround.webp';
import flavoredBeans from '../static/FlavoredBeans.avif';
import classicBeans from '../static/ClassicBeans.avif';
import capsules from '../static/Capsules.avif';

export const CATEGORY_IMAGES: Record<string, string> = {
    'instant-sticks': instantCoffee,
    'flavored-ground': flavoredGround,
    'classic-ground': classicGround,
    'flavored-beans': flavoredBeans,
    'classic-beans': classicBeans,
    'coffee-capsules': capsules,
};